import { KeyboardEvent, useCallback } from "react";

export const useEnterSubmit = (callback: () => void) => {
  const onKeyDown = useCallback(
    (event: KeyboardEvent<HTMLTextAreaElement>) => {
      if (
        // Macは (ctrlKey または metaKey) + Enter、Windowsは ctrlKey + Enter で送信
        event.key === "Enter" &&
        (event.ctrlKey || event.metaKey) &&
        !event.shiftKey &&
        !event.nativeEvent.isComposing
      ) {
        event.preventDefault();
        callback();
      }
    },
    [callback],
  );

  return { onKeyDown };
};
